import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action, select, Store } from '@ngrx/store';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import {
  LoadCategories,
  LoadCategoriesFailure,
  LoadCategoriesSuccess,
  CategoriesActionTypes
} from './categories.actions';
import { BuyerState } from '~app/modules/generic/store';
import { CategoriesService } from '~app/modules/generic/services/categories.service';
import { isCategoriesLoaded } from './categories.selectors';

@Injectable()
export class CategoriesEffects {

  constructor(
    private actions$: Actions,
    private store$: Store<BuyerState>,
    private categoriesService: CategoriesService,
  ) {
  }
  @Effect()
  loadCategories$: Observable<Action> = this.actions$.pipe(
    ofType(CategoriesActionTypes.LOAD_CATEGORIES),
    withLatestFrom(this.store$.pipe(
      select(isCategoriesLoaded),
    ), (action: LoadCategories, isLoaded: boolean) => isLoaded),
    filter((isLoaded) => !isLoaded),
    switchMap(() => {
      return this.categoriesService.getCategories().pipe(
        map(categories => new LoadCategoriesSuccess(categories)),
        catchError(error => of(new LoadCategoriesFailure({ error })))
      );
    })
  );
}
